import { useState, useEffect } from "react";
import { StaffMember } from "src/shared/services/interfacev2";
import { getStaff } from "src/shared/services/servicesv2";

export const useStaff = () => {
  const [staff, setStaff] = useState<StaffMember[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchStaff = async () => {
    setLoading(true);

    try {
      const response = await getStaff();
      setStaff(response.data.result);
    } catch (error) {
      console.error("Error fetching staff:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const refetchStaff = () => {
    fetchStaff();
  };

  return { staff, loading, refetchStaff };
};
